import { useState, useRef,useMemo } from "react";
import { IoCloseOutline } from "react-icons/io5";
import "../ConfirmBooking/ConfirmBook.scss";
import { MdEmail } from "react-icons/md";
import { FaRegUser, FaMobileScreen } from "react-icons/fa6";
import { FileUpload } from "primereact/fileupload";
import { RiFileUploadLine } from "react-icons/ri";
import { FcOk } from "react-icons/fc";
import axios from "axios";
import { postSlotbookurl } from "../../Services/BackendUrl";

const ConfirmBook = ({
  selectedDate,
  courtNumber,
  startTime,
  endTime,
  slotPrice,
  onClose,
  playerCount,
  clearBookingState,
}) => {
  const formattedDate = selectedDate
    ? new Date(selectedDate).toDateString()
    : "";

  const [toaster, setToast] = useState(false);
  const fileUploadRef = useRef(null);

  const [file, setFile] = useState(null);

  const [formData, setFormdata] = useState({
    fromDate: selectedDate,
    toDate : null,
    courtNo: courtNumber,
    from: startTime.replace(".", ":").replace(" ", ""),
    to: endTime.replace(".", ":").replace(" ", ""),
    fullName: "",
    mobileNumber: "",
    email: "",
    price: slotPrice,
    playerCount: playerCount,
  });

  const [error, setError] = useState({});

  const shorten = (name, max = 12) => {
  if (!name) return "Upload File";
  const dot = name.lastIndexOf(".");
  const ext = dot >= 0 ? name.slice(dot) : "";
  const base = dot >= 0 ? name.slice(0, dot) : name;
  return base.length > max ? `${base.slice(0, max)}.....${ext}` : name;
};

  const fileLabel = useMemo(
    () => (file?.name ? shorten(file.name, 12) : "Upload File"),
    [file?.name]
  );


  const validation = () => {
    const errors = {};
    if (!formData.fullName?.trim()) {
      errors.fullName = "Required full name";
    }

    if (!formData.mobileNumber?.trim()) {
      errors.mobileNumber = "Please give the mobile number";
    } else if (!/^\d{8}$/.test(formData.mobileNumber)) {
      errors.mobileNumber = "Mobile number must be 8 digits";
    }

    if (!formData.email?.trim()) {
      errors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email.trim())) {
      errors.email = "Email end with @gmail.com";
    }
    // if (!formData.file) {
    //   errors.file = "File upload is required!";
    // }
    setError(errors);
    return Object.keys(errors).length === 0;
  };

  const handleOnchange = (event) => {
    const { name, value } = event.target;
    setFormdata({ ...formData, [name]: value });
  };

  const handleConfirm = (event) => {
    event.preventDefault();
    if (validation()) {
      const bookslotData = new FormData();

      const slotData = {
        courtNo: formData.courtNo,
        fromDate: formData.fromDate,
        toDate : formData.toDate,
        from: formData.from,
        to: formData.to,
        fullName: formData.fullName,
        mobileNumber: formData.mobileNumber,
        email: formData.email,
        playerCount: formData.playerCount,
        price: formData.price,
      };
      bookslotData.append("data", JSON.stringify(slotData));
      bookslotData.append("file", formData.file);
      axios
        .post(postSlotbookurl, bookslotData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(() => {
          setToast(true);
          setTimeout(() => {
            setToast(false);
            onClose();
          }, 3000);
          setFormdata({
            fullName: "",
            mobileNumber: "",
            email: "",
            file: null,
          });
          clearBookingState();
          fileUploadRef.current?.clear();
        });
    }
  };

  const handleFileRemove = () => {
    setFormdata({ ...formData, file: null });
    fileUploadRef.current?.clear();
  };

  


  return (
    <div className="confirm-book-container">
      <div className="confirm-booking-header">
        <div>{formattedDate}</div>
        <div className="cursor-pointer">
          <IoCloseOutline onClick={onClose} />
        </div>
      </div>
      <hr style={{ color: "gray" }} />

      <div className="first-section">
        <div className="from-to">
          <div className="gap">
            <div style={{ color: "orange" }}>FROM</div>
            <div style={{ color: "gray" }}>{startTime}</div>
          </div>
          <div className="gap">
            <div style={{ color: "orange" }}>To</div>
            <div style={{ color: "gray" }}>{endTime}</div>
          </div>
        </div>
        <div style={{ borderRight: "1px solid gray" }}></div>

        <div className="courtno-slotprice">
          <div className="gap">
            <div style={{ color: "orange" }}>COURT NO</div>
            <div style={{ color: "gray" }}>{courtNumber}</div>
          </div>
          <div className="gap">
            <div style={{ color: "orange" }}>SLOT PRICE</div>
            <div style={{ color: "gray" }}>OMR {slotPrice}</div>
          </div>
        </div>
      </div>
      <hr style={{ color: "gray" }} />
      <form className="form-section">
        <div className="form-heading">FILL YOUR DETAILS</div>
        <div className="form-small-text">Ready to play? Fill out the form</div>
        <div className="input-section">
          <div className="label-input">
            <label> Full Name</label>
            <input
              name="fullName"
              className="confirm-input"
              type="text"
              value={formData.fullName}
              placeholder="Enter your name..."
              onKeyPress={(e) => {
                if (!/^[A-Za-z\s]+$/.test(e.key)) {
                  e.preventDefault();
                }
              }}
              onChange={handleOnchange}
            />
            <FaRegUser
              style={{ position: "absolute", top: "52px", left: "15px" }}
            />
            {error.fullName && (
              <span style={{ color: "red", marginTop: "-10px" }}>
                {error.name}
              </span>
            )}
          </div>
          <div className="label-input">
            <label> Mobile Number</label>
            <input
              name="mobileNumber"
              className="confirm-input"
              type="tel"
              value={formData.mobileNumber}
              placeholder="Enter mobile number..."
              onKeyPress={(e) => {
                if (!/[0-9]/.test(e.key)) {
                  e.preventDefault();
                }
              }}
              maxLength={8}
              onChange={handleOnchange}
            />
            <FaMobileScreen
              style={{ position: "absolute", top: "52px", left: "15px" }}
            />
            {error.mobileNumber && (
              <span style={{ color: "red", marginTop: "-10px" }}>
                {error.mobileNumber}
              </span>
            )}
          </div>
          <div className="label-input">
            <label> Email ID</label>
            <MdEmail
              style={{ position: "absolute", top: "52px", left: "15px" }}
            />
            <input
              name="email"
              className="confirm-input"
              type="email"
              value={formData.email}
              placeholder="Enter email..."
              onChange={handleOnchange}
            />
            {error.email && (
              <span style={{ color: "red", marginTop: "-10px" }}>
                {error.email}
              </span>
            )}
          </div>
          <div className="label-input" >
            <label>Upload Payment Receipt</label>

            <FileUpload
              ref={fileUploadRef}
              key={fileLabel}   
              name="file"
              style={{padding:"10px 20px"}}
              className={`confirm-input file-upload ${formData.file ? "file-selected" : ""
                }`}
              customUpload
               auto={false}
              mode="basic"
              accept="image/*"
              chooseLabel={fileLabel}   
              onSelect={(e) => {
                setFile(e.files?.[0] ?? null)
                const uploadedFile = e.files?.[0];
                if (uploadedFile) {
                  if (uploadedFile.size > 1024 * 1024) {
                    setError({
                      ...error,
                      file: "File size should not exceed 1MB",
                    });
                    setFormdata({ ...formData, file: null });
                    fileUploadRef.current?.clear();
                  } else {
                    setError({ ...error, file: "" }); // clear size error
                    setFormdata({ ...formData, file: uploadedFile });
                  }
                }
              }}

              onClear={() => setFile(null)}

               chooseOptions={{
                icon: <RiFileUploadLine
                  className={`upload-icon ${formData.file ? "selected-icon" : ""}`}
                  size={25}
                  style={{ marginRight: "8px", color: "black" }}
                />,
                iconOnly: false,
                // label: "uplaod file"
              }}
              onClick={handleFileRemove}
              

            />
            {formData.file && (
              <IoCloseOutline
                size={20}
                style={{
                  position: "absolute",
                  top: "54px",
                  right: "8px",
                  background: "white",
                  borderRadius: "50%",
                  padding: "2px",
                  cursor: "pointer",
                }}
                onClick={handleFileRemove}
              />
            )}
            {error.file && (
              <span style={{ color: "red", marginTop: "-10px" }}>
                {error.file}
              </span>
            )}
            <div
              className="reject-text"
              style={{
                fontSize: "0.8rem",
                color: "gray",
                position: "absolute",
                bottom: "-20px",
                right: "0",
              }}
            >
              File should be Pdf, JPEG and PNG
            </div>
          </div>
        </div>
        <button onClick={handleConfirm} className="confirm-btn">
          CONFIRM BOOKING
        </button>

        {toaster && (
          <div className="toaster">
            <div className="toast-message">
              <FcOk />
              Slot has been Successfully Booked
            </div>
          </div>
        )}
      </form>
    </div>
  );
};

export default ConfirmBook;
